import React, { useState } from "react";
import { AddPOForm } from "./AddPOForm";
import styled from "styled-components/macro";
import {
  EditButton,
  PrimaryButtonSmall,
} from "../../../../components/Buttons/Buttons";
import type {
  IPurchaseOrder,
  OrderDocument,
  OrderOrSampleDocument,
  SampleDocument,
  SampleRequest,
  TransactionTypeEnum,
} from "../../../../types/types";
import { PoNumberAndDocumentLink } from "../../../../components/PoNumberAndDocumentLink/PoNumberAndDocumentLink";
import { useTranslation } from "react-i18next";

interface IAddPO {
  orderOrSample: IPurchaseOrder | SampleRequest;
  transactionType: TransactionTypeEnum;
  mutateTypeAndEvents: () => void;
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const InnerTitle = styled.p`
  color: ${({ theme }) => theme.primaryTextColor};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
`;

export const AddPO = ({
  orderOrSample,
  transactionType,
  mutateTypeAndEvents,
}: IAddPO) => {
  const { t } = useTranslation();
  const [addingPO, setAddingPO] = useState(false);
  const poNumber = orderOrSample.alternative_po_number;
  const kind =
    transactionType === "sample-requests" ? "sample_request" : "purchase_order";
  const documents = orderOrSample.documents as OrderOrSampleDocument[];

  const poDocument = documents.find(
    (doc: OrderDocument | SampleDocument) => doc.kind === kind
  );

  const packingListDocument = documents.find(
    (doc: OrderDocument | SampleDocument) => doc.kind === "packaging_list"
  );

  return (
    <>
      {!addingPO && (
        <>
          <Row>
            <InnerTitle>{t("PO Number")}</InnerTitle>
            {poNumber &&
              !packingListDocument &&
              orderOrSample.status !== "completed" && (
                <EditButton
                  testid={"add-po-number"}
                  onClick={() => setAddingPO(true)}
                />
              )}
            {!poNumber && orderOrSample.status !== "completed" && (
              <PrimaryButtonSmall onClick={() => setAddingPO(true)}>
                {t("Add")}
              </PrimaryButtonSmall>
            )}
          </Row>
          {poNumber && (
            <PoNumberAndDocumentLink
              poNumber={poNumber}
              poDocument={poDocument}
            />
          )}
        </>
      )}
      {addingPO && (
        <AddPOForm
          order_number={orderOrSample.id}
          show={setAddingPO}
          PONumber={poNumber}
          PODocument={poDocument}
          addPO={addingPO}
          transactionType={transactionType}
          mutateTypeAndEvents={mutateTypeAndEvents}
        />
      )}
    </>
  );
};
